import { useSnackbar } from "notistack";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../data/network/services/ApiRequestPost";
import { authAction } from "../../data/redux/action/authAction";
import {
  startFullScreenLoadingAction,
  stopFullScreenLoadingAction,
} from "../../data/redux/action/fullScreenLoadingAction";
import {
  clearIntervalId,
  removeJobAction,
} from "../../data/redux/action/scheduleJobAction";
import secureStorage from "../../utility/secureStorage";
import { SIDEBAR_COLOR } from "../resources/colorsManager";
import { SUCCESS } from "../resources/constantsManager";
import { SS_INTERVAL_ID } from "../resources/secureStorageManager";

const DropdownOptions = ({ clickHandle, title }) => {
  const [color, setColor] = useState("black");
  return (
    <>
      <p
        style={{
          fontSize: 16,
          marginBottom: 5,
          cursor: "pointer",
          color: color,
        }}
        onClick={() => {
          clickHandle();
        }}
        onMouseEnter={() => {
          setColor(SIDEBAR_COLOR);
        }}
        onMouseLeave={() => {
          setColor("black");
        }}
        className="roboto"
      >
        {title}
      </p>
    </>
  );
};

function TopNavBarDropdown({ clickHandle, intervalId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const logoutApp = () => {
    dispatch(startFullScreenLoadingAction());
    ApiRequestPost.logout()
      .then(async (data) => {
        if (data.status === SUCCESS) {
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          const id = await secureStorage.getItem(SS_INTERVAL_ID);
          for (let i = 0; i < 100; i++) {
            window.clearInterval(i);
          }
          dispatch(authAction(false));
          dispatch(removeJobAction());
          dispatch(clearIntervalId());
          clearInterval(id);
          secureStorage.clear();
          navigate("/login");
        } else {
          if (data?.message === "User already logged out") {
            secureStorage.clear();
            dispatch(authAction(false));
            navigate("/login");
            enqueueSnackbar("Logged out SuccessFully", {
              variant: "success",
            });
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        dispatch(stopFullScreenLoadingAction());
      });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        paddingLeft: 20,
      }}
      className="latoRegular"
    >
      <DropdownOptions
        clickHandle={() => {
          navigate("/profile");
          clickHandle();
        }}
        title="My Profile"
      />

      <DropdownOptions
        clickHandle={() => {
          logoutApp();
        }}
        title="Logout"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    seconds: state.scheduleJobReducer.seconds,
    intervalId: state.scheduleJobReducer.intervalId,
  };
};

export default connect(mapStateToProps)(TopNavBarDropdown);
